module.exports = __webpack_public_path__ + "img/Done.cc0da0d5.png";